import React, { useEffect, useState } from "react";
import { Card, Switch, Space, Typography, message, Alert, Spin } from "antd";
import {
  isOwnDeliveryEnabled,
  setOwnDeliveryEnabled,
} from "../../services/ownDeliveryService";

const { Title, Text, Paragraph } = Typography;

const OwnDeliveryTab: React.FC = () => {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      setEnabled(await isOwnDeliveryEnabled());
    } catch (error) {
      console.error("Error loading own delivery setting:", error);
      message.error("Failed to load Own Delivery setting");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const handleToggle = async (checked: boolean) => {
    setSaving(true);
    try {
      await setOwnDeliveryEnabled(checked);
      setEnabled(checked);
      message.success(
        checked
          ? "Own Delivery is now available in shipping options"
          : "Own Delivery is hidden from shipping options",
      );
    } catch (error) {
      console.error("Error saving own delivery setting:", error);
      message.error("Failed to update Own Delivery setting");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <Card>
        <Space align="center" style={{ marginBottom: 16 }}>
          <Title level={4} style={{ margin: 0 }}>
            E-Freight Own Delivery
          </Title>
          <Text type="secondary">
            Self-delivery with printable labels (no Sendcloud)
          </Text>
        </Space>

        <Alert
          type="info"
          showIcon
          style={{ marginBottom: 16 }}
          message="Uses existing LMD rates for invoicing"
          description={
            <Paragraph style={{ marginBottom: 0 }}>
              When you create an Own Delivery shipment, the entered pallet count
              is stored on the booking delivery and used by the invoice LMD
              calculation. There is no separate price list — configure rates
              under <Text strong>LMD Rates</Text>.
            </Paragraph>
          }
        />

        {loading ? (
          <Spin />
        ) : (
          <Space direction="vertical" size="middle">
            <Space align="center">
              <Switch
                checked={enabled}
                loading={saving}
                onChange={handleToggle}
                checkedChildren="On"
                unCheckedChildren="Off"
              />
              <Text>
                Show <Text strong>Own Delivery</Text> card in shipping options
              </Text>
            </Space>
            <Text type="secondary" style={{ fontSize: 12 }}>
              Creates one local shipment + label per pallet (delivery ID only, no
              track &amp; trace).
            </Text>
          </Space>
        )}
      </Card>
    </div>
  );
};

export default OwnDeliveryTab;
